<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" [id]="modalName" tabindex="-1"
    aria-labelledby="changePackageModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-height-transition">
        <div #modalContent class="modal-content glassmorphism-card rounded-lg px-2 px-lg-5 py-3">
            <div class="modal-header border-bottom-0 pb-0">
                <h4 class="modal-title font-weight-bold" id="changePackageModalLabel">تغيير الباقة</h4>
                <button (click)="changeStatusToClosed(modalName)" #closeButton type="button" class="btn-close"
                    data-bs-dismiss="modal" aria-label="Close" title="إغلاق"></button>
            </div>
            
            <div class="modal-body pt-0">
                    <!-- Loading Spinner -->
                    <app-loader-spinner [color]="'success'" *ngIf="isLoading"></app-loader-spinner>

                <!-- Step 1: Parent Type Selection -->
                <ng-container *ngIf="step == 1 && !isLoading" >
                    <h5 class="decorated font-weight-bold mt-5 mt-lg-0"><span>اختر نوع الاشتراك</span></h5>

                    <div class="tab-container">
                        <div class="tab-toggle">
                          <button
                            *ngFor="let parent of getcategorys()"
                            class="tab-option"
                            [class.active]="selectedcategory === parent"
                            (click)="changecategory(parent)">
                            {{ parent | titlecase }}
                          </button>
                        </div>
                      </div>
                                                                                  

                    <!-- Packages Content -->
<!-- Packages Content -->
<div class="tab-content transition-fade" [class.fade-out]="!showContent" [class.fade-in]="showContent" *ngIf="!isLoading">
    <ng-container *ngIf="parsedPackages[selectedcategory]">
      <!-- Optional: Title per type -->
      <div class="mt-3">
        <h5 class="font-weight-bold border-bottom mt-5 mt-lg-0 pb-3 text-start">
          باقات {{ selectedcategory | titlecase }}
        </h5>
  
        <div class="packages-grid mt-4" *ngIf="parsedPackages[selectedcategory]?.length">
            <ng-container *ngFor="let item of parsedPackages[selectedcategory]">
              <div class="package-item" (click)="selectPackage(item)">
                <app-voucher
                  [filled]="false"
                  [price]="item?.description.price"
                  [speed]="item?.description.speed"
                  [quota]="item?.description.quota"
                  [name]="item?.description.name"
                  [quotaUnit]="item?.description.quota_unit"
                  [limited]="item?.description.type?.toLowerCase() === 'unlimited' ? 'false' : 'true'">
                </app-voucher>
              </div>
            </ng-container>
          </div>
      </div>
    </ng-container>
  
    <div *ngIf="!parsedPackages[selectedcategory]?.length" class="alert alert-warning mt-4 text-center">
        لا توجد باقات متاحة في هذه الفئة.
      </div>
      </div>
                  </ng-container>
                <div class="row h-100 mt-3">

                        <!-- Step 2: Confirm Selection -->
                        <ng-container *ngIf="step == 2">
                            <h5 class="decorated font-weight-bold mt-5 mt-lg-0"><span>باقتك</span></h5>
                            <ng-container *ngIf="!isLoading">
                                <div class="row h-100 mt-3">
                                    <div class="col-6 col-lg-5 col-xl-3 mx-auto">
                                        <app-voucher [filled]="true"
                                        [price]="selectedPackage?.description?.price"
                                        [speed]="selectedPackage?.description?.speed"
                                        [quota]="selectedPackage?.description?.quota"
                                        [name]="item?.description.name"
                                        [quotaUnit]="selectedPackage?.description?.quota_unit"
                                        [limited]="selectedPackage?.description?.type?.toLowerCase() == 'unlimited' ? 'false' : 'true'">
                                    </app-voucher>
                                </div>
                                </div>
                            </ng-container>
        
                            <div class="text-center mt-4">
                                <h5>هل أنت متأكد من تغيير الباقة؟</h5>
                                <button (click)="step = 1" 
                                        class="btn btn-outline-dark w-auto rounded-pill mx-auto pt-0 px-4 mt-2 me-2" 
                                        [disabled]="isLoading">
                                    رجوع
                                </button>
                                <button (click)="changePackage()" 
                                        class="btn btn-success w-auto rounded-pill mx-auto pt-0 px-4 mt-2" 
                                        [disabled]="isSending || isLoading">
                                    تأكيد
                                </button>
                            </div>
                        </ng-container>
                    </div>

                 <!--   <ng-container  *ngIf="step == 2">

                        <h5 class="font-weight-bold text-center"><small>سعر الباقة الجديدة</small></h5>
                        <h1 class="text-larger-1 mb-0 text-center">
                            <span class="narrow-number">{{ selectedPackage?.description?.price }}</span>
                            <span class="text-smaller">دل</span>
                        </h1>
    
                        <div class="text-center mt-4">
                            <h5>هل أنت متأكد من تغيير الباقة؟</h5>
                            <button (click)="step = 1" class="btn btn-outline-dark w-auto rounded-pill mx-auto pt-0 px-4 mt-2 me-2" [disabled]="isLoading">رجوع</button>
                            <button (click)="changePackage()" class="btn btn-success w-auto rounded-pill mx-auto pt-0 px-4 mt-2" [disabled]="isSending || isLoading">تأكيد</button>
    
                        </div>
                    </ng-container> -->
                </div>
        </div>
    </div>
</div>
